<template>
  <div :class="isMobile ? 'column' : 'row'">
    <img
      :src="img"
      v-if="img"
      alt="Information Vehicle"
      :class="[
        'vehicle-image',
        isMobile ? 'full-width' : 'col-xs-5 col-sm-5 col-md-4 col-lg-4'
      ]"
    />
    <div :class="isMobile ? 'q-mt-lg' : 'col q-pl-lg'">
      <SAITitle text-align="left">{{ title }}</SAITitle>
      <p class="q-mt-sm">{{ body }}</p>
      <div class="row justify-start q-mt-lg" v-if="link">
        <SAIBtn
          v-if="link"
          padding="14px xl md"
          outline
          no-caps
          type="a"
          :href="link"
          target="_blank"
        >
          <p class="text-weight-medium">Find out more</p>
        </SAIBtn>
      </div>
    </div>
  </div>
</template>

<script>
import { SAITitle, SAIBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'NovatedLeasingInformation',
  props: {
    title: String,
    body: String,
    img: String,
    link: String,
    isMobile: Boolean
  },
  components: {
    SAITitle,
    SAIBtn
  }
};
</script>

<style lang="sass" scoped>
.vehicle-image
  object-fit: contain
  object-position: top
</style>
